import template from './drag-and-drop.html';

export default angular
  .module('app')
  .directive('holdingDragAndDrop', holdingDragAndDrop)
  .name;

function holdingDragAndDrop() {
  'ngInject';

  return {
    link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      fileTypes: '=',
      maxFiles: '=',
      maxSize: '=',
      maxTotalSize: '=',
      parentError: '=?'
    },
    template,
  };

  function link(scope, _element, attrs, ctrl) {
    function ctrlValueUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        scope.model.document = newDoc;
      }
    }

    function documentModelUpdated(newDoc, oldDoc) {
      if (newDoc !== oldDoc) {
        ctrl.$setViewValue(newDoc);
      }
    }

    function initiateSelection(event) {
      angular.element('#dragAndDropInput').trigger('click');
      if (event) {
        event.preventDefault();
      }
    }

    function onNoBrowseChanged() {
      scope.noBrowseLabel = (('noBrowseLabel' in attrs) && angular.isDefined(attrs.noBrowseLabel));
    }

    const model = {
      document: null
    };

    scope.initiateSelection = initiateSelection;
    scope.model = angular.copy(model);

    attrs.$observe('noBrowseLabel', onNoBrowseChanged);
    scope.$watch('model.document', documentModelUpdated);
    scope.$watch(() => ctrl.$viewValue, ctrlValueUpdated);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/directives/drag-and-drop/drag-and-drop.js